import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { store } from "./store";
import { ORIGIN_CLIENT_ID } from "./utils/constants";
import ThemeProvider from './styles/themeProvider';

const clientId = ORIGIN_CLIENT_ID;

// Get the root element from the DOM
const rootElement = document.getElementById("root");

// Create a root using the createRoot API
const root = ReactDOM.createRoot(rootElement);

// Render the application
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={clientId}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
